import React, { useContext } from 'react';
import { CreateOrderContext } from '../contexts/create-order-context';
import StatusTabs from 'components/base/status-tabs';

const CreateOrderTab = () => {
  const { setActive, active, tabIsdisabled, tabList } = useContext(CreateOrderContext);
  return (
    <div className='flex gap-2'>
      <StatusTabs
        list={tabList}
        type='outline'
        active={active}
        setActive={setActive}
        disabled={tabIsdisabled}
      />
    </div>
  );
};

export default CreateOrderTab;
